import { Component, OnInit, TemplateRef } from "@angular/core";
import { ContextService } from "@core/service/context.service";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { BehaviorSubject } from "rxjs";
import { IContextCompany, IContextProperty } from "@schema/context";

import { IconList } from "@schema/ui/icons";
import { faExternalLink } from "@fortawesome/pro-regular-svg-icons";

@Component({
  selector: "app-context-current",
  templateUrl: "./context-current.component.html",
  styleUrls: ["./context-current.component.scss"]
})
export class ContextCurrentComponent implements OnInit {

  public company$: BehaviorSubject<IContextCompany>;

  public property$: BehaviorSubject<IContextProperty>;

  /**
   * A list of Font Awesome icons used in this component
   */
  public icons: IconList = {
    openContext: faExternalLink,
  };

  /**
   * The context switcher modal reference
   */
  protected _modal: NgbModalRef;

  constructor(
    protected _contextService: ContextService,
    protected _modalService: NgbModal,

  ) { }

  ngOnInit(): void {
    this.company$ = this._contextService.company$;
    this.property$ = this._contextService.property$;
  }

  /**
   * Show the context switcher overlay
   */
  public showContextOverlay(content: TemplateRef<ContextCurrentComponent>): void {
    this._modal = this._modalService.open(content, {
      centered: true,
    });
  }

  /**
   * Handle the modal when the user cancels/changes context
   */
  public closeContextOverlay(): void {
    this._modal.close();
  }

}
